import React from "react";
import { Route, Redirect } from "react-router-dom";
import Login from "../pages/Login";

import "../assets/css/style.css";
import "../assets/css/responsive.css";
import Terms from "../pages/Terms";
import Policy from "../pages/Policy";
import Share from "../pages/Share";

const LoginRouter = () => (
  <React.Fragment>
    <Route exact path="/" render={() => <Redirect to="/login/" />} />
    <Route path="/login/" exact component={Login} />
    <Route path="/terms/" exact component={Terms} />
    <Route path="/policy/" exact component={Policy} />
    <Route path="/share/" exact component={Share} />
  </React.Fragment>
);

export default LoginRouter;
